import { render, staticRenderFns } from "./WhatsAppButton.vue?vue&type=template&id=7513fe10&scoped=true"
import script from "./WhatsAppButton.vue?vue&type=script&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppButton.vue?vue&type=style&index=0&id=7513fe10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7513fe10",
  null
  
)

export default component.exports